import { Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { environment } from "@environments/environment";
import { catchError, Observable, throwError } from "rxjs";
import {
  Token, Login, ValidateResponse, ApiResponse, ValidateCode, PasswordChange,
  OtpRequest, OtpValidateRequest, OtpVm, MagicLinkRequest, InvitationInfo,
  RegisterWithInvitationRequest, RegistrationResult
} from "@core/types";

@Injectable({
  providedIn: 'root',
})

export class AuthService {
  baseUrl: string;


  constructor(private httpClient: HttpClient,) {
    this.baseUrl = environment.api + '/auth';
  }

  login(item: Login): Observable<ApiResponse<Token>> {
    return this.httpClient.post<ApiResponse<Token>>(this.baseUrl, item)
      .pipe(catchError((errorReponse: HttpErrorResponse) => {
        return throwError(() => `${errorReponse.error.message}`);
      }));
  }

  changePassword(item: PasswordChange): Observable<ApiResponse<string>> {
    return this.httpClient.patch<ApiResponse<string>>(this.baseUrl + '/changePassword', item)
      .pipe(catchError((errorReponse: HttpErrorResponse) => {
        return throwError(() => `${errorReponse.error.message}`);
      }));
  }

  resendCode(regHash: string): Observable<ApiResponse<string>> {
    return this.httpClient.post<ApiResponse<string>>(this.baseUrl + '/ReSendValidationCode', { hash: regHash })
      .pipe(catchError((errorReponse: HttpErrorResponse) => {
        return throwError(() => `${errorReponse.error.message}`);
      }));
  }

  validateCode(validateCode: ValidateCode): Observable<ApiResponse<ValidateResponse>> {
    return this.httpClient.post<ApiResponse<ValidateResponse>>(this.baseUrl + '/ValidateCode', validateCode)
      .pipe(catchError((errorReponse: HttpErrorResponse) => {
        return throwError(() => `${errorReponse.error.message}`);
      }));
  }

  refreshToken(refreshToken: string): Observable<ApiResponse<Token>> {
    return this.httpClient.post<ApiResponse<Token>>(this.baseUrl + '/refresh', { refreshToken })
      .pipe(catchError((errorReponse: HttpErrorResponse) => {
        return throwError(() => `${errorReponse.error.message}`);
      }));
  }

  requestOtp(item: OtpRequest): Observable<ApiResponse<OtpVm>> {
    return this.httpClient.post<ApiResponse<OtpVm>>(this.baseUrl + '/login/otp', item)
      .pipe(catchError((errorReponse: HttpErrorResponse) => {
        return throwError(() => `${errorReponse.error.message}`);
      }));
  }

  validateOtp(item: OtpValidateRequest): Observable<ApiResponse<boolean>> {
    return this.httpClient.post<ApiResponse<boolean>>(this.baseUrl + '/login/otp/validate', item)
      .pipe(catchError((errorReponse: HttpErrorResponse) => {
        return throwError(() => `${errorReponse.error.message}`);
      }));
  }

  requestMagicLink(item: MagicLinkRequest): Observable<ApiResponse<string>> {
    return this.httpClient.post<ApiResponse<string>>(this.baseUrl + '/login/magic-link', item)
      .pipe(catchError((errorReponse: HttpErrorResponse) => {
        return throwError(() => `${errorReponse.error.message}`);
      }));
  }

  redeemMagicLink(token: string): Observable<ApiResponse<Token>> {
    return this.httpClient.post<ApiResponse<Token>>(this.baseUrl + '/login/magic-link/redeem', { token })
      .pipe(catchError((errorReponse: HttpErrorResponse) => {
        return throwError(() => `${errorReponse.error.message}`);
      }));
  }

  validateInvitation(code: string): Observable<ApiResponse<InvitationInfo>> {
    return this.httpClient.post<ApiResponse<InvitationInfo>>(this.baseUrl.replace('/auth', '') + '/register/validate-invitation', { code })
      .pipe(catchError((errorReponse: HttpErrorResponse) => {
        return throwError(() => `${errorReponse.error.message}`);
      }));
  }

  registerWithInvitation(item: RegisterWithInvitationRequest): Observable<ApiResponse<RegistrationResult>> {
    return this.httpClient.post<ApiResponse<RegistrationResult>>(this.baseUrl.replace('/auth', '') + '/register/with-invitation', item)
      .pipe(catchError((errorReponse: HttpErrorResponse) => {
        return throwError(() => `${errorReponse.error.message}`);
      }));
  }

}
